import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index.js'

const querystring = require('querystring')

const onSuccess = (response) => {
  return Promise.resolve(response)
}

const onError = (e) => {
  switch(e.response.status) {
    case 401:
      router.replace('/sign_in')
      break
  }
  return Promise.reject(e.response)
}

export default {
  baseUrl() {
    return process.env.BASE_PROTOCOL + '://' + process.env.BASE_ADDRESS + '/';
  },

  post: function (url, form_data) {
    return axios.post(this.baseUrl() + url, form_data, { headers: {
      'content-type': 'multipart/form-data',
      'Authorization': 'Bearer ' + store.state.auth.appToken
    }})
      .then(onSuccess)
      .catch(onError)
  }
}
